// Enterprise License Usage Model
export class EnterpriseLicenseUsage {
  constructor(data = {}) {
    this.enterpriseId = data.enterpriseId || null;
    this.enterpriseName = data.enterpriseName || '';
    this.maxLicenses = data.maxLicenses || 0;
    this.currentLicenses = data.currentLicenses || 0;
    this.availableLicenses = data.availableLicenses || 0;
  }
}
